import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";
import { getCostShareSubtotal, getPeriodSubtotal } from "utils/budgetBuilder";

import styles from "./styles.css";


export const OverviewTotalCostShare = () => {
	const { currencyFormatter } = useTenantFormatter();
	const periodList = useSelector(budgetBuilderSelectors.periodRows);
	const externalCostShareByPeriod = useSelector(budgetBuilderSelectors.externalCostShareByPeriod);
	const internalCostShareByPeriod = useSelector(budgetBuilderSelectors.internalCostShareByPeriod);
	const researchTeamByPeriod = useSelector(budgetBuilderSelectors.researchTeamByPeriod);

	const totalsByPeriod = useMemo(() => {
		const totals = {};
		for (let period of periodList) {
			let total = 0;
			total += getCostShareSubtotal(internalCostShareByPeriod?.[period.periodNumber]);
			total += getCostShareSubtotal(externalCostShareByPeriod?.[period.periodNumber]);
			total += getPeriodSubtotal(researchTeamByPeriod?.[period.periodNumber], true);
			totals[period.periodNumber] = total;
		}

		return totals;
	}, [ externalCostShareByPeriod, internalCostShareByPeriod, periodList, researchTeamByPeriod ]);

	const total = useMemo(
		() => Object.values(totalsByPeriod).reduce((runningTotal, total) => runningTotal + total, 0),
		[ totalsByPeriod ]
	);

	return (
		<Table.Row className={`${styles.rowHeader}`}>
			<Table.Cell className={`${styles.cellAlignLeft} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{"Total Cost Share"}</span>
			</Table.Cell>
			{Object.entries(totalsByPeriod).map(([ p, total ]) => (
				<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`} key={`period-${p}`}>
					<span className={styles.bold}>{currencyFormatter(total)}</span>
				</Table.Cell>
			))}
			<Table.Cell className={`${styles.cellAlignRight} ${styles.rowHeaderCell}`}>
				<span className={styles.bold}>{currencyFormatter(total)}</span>
			</Table.Cell>
		</Table.Row>
	);
};
